import { render, staticRenderFns } from "./modern-zen.vue?vue&type=template&id=721cb936"
import script from "./modern-zen.vue?vue&type=script&lang=js"
export * from "./modern-zen.vue?vue&type=script&lang=js"
import style0 from "./modern-zen.vue?vue&type=style&index=0&id=721cb936&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports